export default class GtmPlugin {
  constructor(options) {
    this.options = options
  }

  hasBrowserContext() {
    return typeof window !== 'undefined'
  }

  dataLayer() {
    if (this.hasBrowserContext()) {
      return (window.dataLayer = window.dataLayer ?? [])
    }
    return false
  }

  shouldDebug() {
    return this.options.debug ?? false
  }

  trackView(name, path, url, locale, customerNumber, additionalData = {}) {
    if (this.options.debug) {
      console.log('Track View', { name, path, url, locale, customerNumber, ...additionalData })
    }

    if (this.hasBrowserContext() && this.options.enabled) {
      const dataLayer = (window.dataLayer = window.dataLayer ?? [])

      // Fields as defined in https://docs.google.com/spreadsheets/d/1yKo69YY5TaJg1ZCxpXkxT8L7Qc8OrkKBilNtNRbqYys
      dataLayer.push({
        ...additionalData,
        event: 'PageView',
        pageName: name,
        path,
        url,
        customerNumber: customerNumber ?? this.options.customerNumber,
        language: locale ?? this.options.language,
        content_group: additionalData.content_group ?? name,
      })
    }
  }

  trackEvent({ event = 'default', data } = {}) {
    const dataLayer = (window.dataLayer = window.dataLayer ?? [])
    const lastPageView = dataLayer.slice().findLast(obj => obj.event === 'PageView')
    const lastContentGroup = lastPageView ? lastPageView.content_group : 'fallback_feb'

    if (this.options.debug) {
      console.log('Track Event', {
        event,
        customerNumber: this.options.customerNumber,
        content_group: lastContentGroup,
        ...data,
      })
    }

    if (this.hasBrowserContext()) {
      dataLayer.push({
        event,
        customerNumber: this.options.customerNumber,
        content_group: lastContentGroup,
        ...data,
      })
    }
  }
}
